import { render, staticRenderFns } from "./cpo-millsCluster-summary.vue?vue&type=template&id=55a2746c&scoped=true&"
import script from "./cpo-millsCluster-summary.vue?vue&type=script&lang=js&"
export * from "./cpo-millsCluster-summary.vue?vue&type=script&lang=js&"
import style0 from "./cpo-millsCluster-summary.vue?vue&type=style&index=0&id=55a2746c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2746c",
  null
  
)

export default component.exports